import React from "react";
import Slider from "./Slider";
import FeatureCategory from "./categories/FeatureCategory";
import FeatureProduct from "./Products/FeatureProduct";
import Why from "../Why/Why";
import HeroBanner from "./Home/HeroBanner";
import Categories from "./Category/Categories";
// import { Slider } from "react-toastify";
//
const images = ["/slides/1.webp", "/slides/2.webp", "/slides/3.webp"];

const Hero = () => {
  return (
    <div className="bg-white">
      <HeroBanner />
      <Categories />
      <FeatureProduct />
      <Why />
    </div>
  );
};

export default Hero;
